import LiveTrackerModel from '../../models/trackers/live-tracker.model';
import StatisticsTrackerModel from '../../models/trackers/statistics-tracker.model';
const _state = {
  /**
   * Bsports tracker data from liveMatchesLive hub
   * @type {LiveTrackerModel}
   */
  bsportsTrackerData: {},
  /**
   * Bsports tracker data from liveMatchStatistics hub
   * @type {StatisticsTrackerModel}
   */
  bsportsStatisticsData: {},
};
/**
 * Vuex store - BsportsTracker module
 */
export const BsportsTrackerModule = {
  state: _state,
  mutations: {
    /**
     * Set bsports tracker data for current event
     * @param {_state} state
     * @param {*} param1
     */
    setBsportsTrackerData(state, { data }) {
      // state.bsportsTrackerData = new LiveTrackerModel(data, singleLiveMatch);
      state.bsportsTrackerData = new LiveTrackerModel(data);
    },
    /**
     * Set bsports statistics data for current event
     * @param {_state} state
     * @param {*} param1
     */
    setBsportsStatisticsData(state, { data }) {
      state.bsportsStatisticsData = new StatisticsTrackerModel(data);
    },
  },
  getters: {
    /**
     * Get bsports tracker data for current event
     * @param {_state} state 
     */
    getBsportsTrackerData(state) {
      return state.bsportsTrackerData;
    },
    /**
     * Get bsports statistics data for current event
     * @param {_state} state 
     */
    getBsportsStatisticsData(state) {
      return state.bsportsStatisticsData;
    },
  },
};
